(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiny-post-landing"] && !Shopify.designMode) return;
  try {
    
/* =========================================================
   Tiny Post — page JS
   - Smooth scroll for in-page anchors
   - Single-open accordion behaviour for FAQ
   - Language toggle (visual state only — connect to Shopify locale switcher)
   - Sticky nav shadow on scroll
   ========================================================= */
(function(){
  // --- Sticky nav shadow on scroll
  var nav = document.querySelector('.nav');
  function onScroll(){
    if(window.scrollY > 8){
      nav.style.boxShadow = '0 6px 22px -16px rgba(31,58,95,.35)';
    }else{
      nav.style.boxShadow = 'none';
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // --- Smooth-scroll anchor links (offset for sticky nav)
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id.length < 2) return;
      var target = document.querySelector(id);
      if(!target) return;
      e.preventDefault();
      var navH = nav.offsetHeight;
      var top = target.getBoundingClientRect().top + window.scrollY - navH - 10;
      window.scrollTo({ top: top, behavior:'smooth' });
    });
  });

  // --- FAQ accordion: only one open at a time
  var faqs = document.querySelectorAll('.faq');
  faqs.forEach(function(d){
    d.addEventListener('toggle', function(){
      if(d.open){
        faqs.forEach(function(other){ if(other!==d){ other.open=false; }});
      }
    });
  });

  // --- Language toggle visual state (wire to Shopify locale_url in production)
  var langButtons = document.querySelectorAll('.lang-toggle button');
  langButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      langButtons.forEach(function(b){
        b.classList.remove('active');
        b.setAttribute('aria-selected','false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected','true');
      /* SHOPIFY NOTE:
         Replace this with: window.location.href = '{{ shop.url }}' + '/' + btn.textContent.toLowerCase();
         or render two <a> tags with {{ link.url | localized }} URLs. */
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
